import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { AdminService } from '@niko-crm/ui';
import { RoleActions } from './role.actions';
import { extractError } from '../helpers/error-reader';

@Injectable()
export class RoleEffects {
  private readonly actions$ = inject(Actions);
  private readonly adminService = inject(AdminService);

  loadRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.loadRoles),
      switchMap(({ page, limit }) =>
        this.adminService.getRoles(page, limit).pipe(
          map((result) => RoleActions.loadRolesSuccess({ result })),
          catchError((err) =>
            of(RoleActions.loadRolesFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );

  createRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.createRole),
      switchMap(({ payload }) =>
        this.adminService.createRole(payload.name, payload.tenantId, payload.description).pipe(
          map((role) => RoleActions.createRoleSuccess({ role })),
          catchError((err) =>
            of(RoleActions.createRoleFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );

  updateRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.updateRole),
      switchMap(({ id, payload }) =>
        this.adminService.updateRole(id, payload).pipe(
          map((role) => RoleActions.updateRoleSuccess({ role })),
          catchError((err) =>
            of(RoleActions.updateRoleFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );

  cloneRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.cloneRole),
      switchMap(({ sourceId, tenantId }) =>
        this.adminService.cloneRole(sourceId, tenantId).pipe(
          map((role) => RoleActions.cloneRoleSuccess({ role })),
          catchError((err) =>
            of(RoleActions.cloneRoleFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );
}
